import FieldConfig from "../../../proto/field-config"
import FieldEstimatedCost from "./estimated-cost"
import {EntityType} from "../../../../gd/const/item";

export default class FieldEstimatedCostExternal extends FieldEstimatedCost {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Estimated service cost"
        this.typeDescription    = "Estimated service cost field"

        this.label              = _.get(config, 'label', this.typeLabel)

        switch (this.entityType) {
            case EntityType.PROJECT:
                this.variableName       = '{PROJECT-ESTIMATED-SERVICE-COST}'
                break
        }
    }
}
